import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

const PortfolioGridESGTable = () => {
  const columns = [
    { field: "id", headerName: "ID", width: 20, hide: true },
    {
      field: "buildingName",
      headerName: "Building Name",
      width: 250,
      editable: false,
    },
    {
      field: "location",
      headerName: "Location",
      width: 180,
      editable: false,
    },
    {
      field: "buildingType",
      headerName: "Building Type",
      width: 140,
      editable: false,
    },
    {
      field: "managedSpace",
      headerName: "Managed Square Footage",
      width: 120,
      editable: false,
    },
    {
      field: "energyConsumption",
      headerName: "Energy Consumption",
      width: 120,
      editable: false,
    },
    {
      field: "waterUsage",
      headerName: "Water Usage",
      width: 120,
      editable: false,
    },
    {
      field: "wasteManagement",
      headerName: "Waste Management Efficiency",
      width:180,
      editable: false,
    },
    {
      field: "socialInteraction",
      headerName: "Social Interactions Tracked (e.g., Engagement Sessions)",
      width: 230,
      editable: false,
    },
    {
      field: "accessibilityCompliance",
      headerName: "Accessibility Compliance",
      width: 200,
      editable: false,
    },
    {
      field: "employeeSatisfaction",
      headerName: "Employee Satisfaction (Survey Score)",
      width: 200,
      editable: false,
    },
    {
      field: "leedCertLevel",
      headerName: "LEED Certification Level",
      width: 200,
      editable: false,
    },
  ];

  const rows = [
    {
      id: 1,
      buildingName: "Contoso Tower - Toronto",
      location: "Downtown Toronto, ON",
      buildingType: "Office",
      managedSpace: 150000,
      energyConsumption: 120000, // kWh
      waterUsage: 20000, // gallons
      wasteManagement: 85, // percentage
      socialInteraction: 15, // number of sessions
      accessibilityCompliance: 100, // percentage
      employeeSatisfaction: 4.5, // survey score (out of 5)
      leedCertLevel: "Platinum",
    },
    {
      id: 2,
      buildingName: "Contoso Plaza - Ottawa",
      builtYear: 2015,
      location: "ByWard Market, Ottawa, ON",
      buildingType: "Mixed-Use",
      managedSpace: 120000,
      energyConsumption: 95000, // kWh
      waterUsage: 15000, // gallons
      wasteManagement: 78, // percentage
      socialInteraction: 10, // number of sessions
      accessibilityCompliance: 95, // percentage
      employeeSatisfaction: 4.2, // survey score (out of 5)
      leedCertLevel: "Gold",
    },
    {
      id: 3,
      buildingName: "Contoso Residences - Vancouver",
      builtYear: 2018,
      location: "Coal Harbour, Vancouver, BC",
      buildingType: "Residential",
      managedSpace: 90000,
      energyConsumption: 70000, // kWh
      waterUsage: 12000, // gallons
      wasteManagement: 90, // percentage
      socialInteraction: 20, // number of sessions
      accessibilityCompliance: 100, // percentage
      employeeSatisfaction: 4.8, // survey score (out of 5)
      leedCertLevel: "Silver",
    },
    {
      id: 4,
      buildingName: "Contoso Innovation Hub - Calgary",
      builtYear: 2021,
      location: "Downtown Calgary, AB",
      buildingType: "Office",
      managedSpace: 200000,
      energyConsumption: 130000, // kWh
      waterUsage: 25000, // gallons
      wasteManagement: 82, // percentage
      socialInteraction: 12, // number of sessions
      accessibilityCompliance: 90, // percentage
      employeeSatisfaction: 4.3, // survey score (out of 5)
      leedCertLevel: "Gold",
    },
    {
      id: 5,
      buildingName: "Contoso Heights - Montreal",
      builtYear: 2016,
      location: "Plateau Mont-Royal, Montreal, QC",
      buildingType: "Residential",
      managedSpace: 110000,
      energyConsumption: 110000, // kWh
      waterUsage: 18000, // gallons
      wasteManagement: 75, // percentage
      socialInteraction: 8, // number of sessions
      accessibilityCompliance: 85, // percentage
      employeeSatisfaction: 4.0, // survey score (out of 5)
      leedCertLevel: "Certified",
    },
    {
      id: 6,
      buildingName: "Contoso Wellness Center - Halifax",
      builtYear: 2012,
      location: "Downtown Halifax, NS",
      buildingType: "Healthcare",
      managedSpace: 95000,
      energyConsumption: 150000, // kWh
      waterUsage: 30000, // gallons
      wasteManagement: 88, // percentage
      socialInteraction: 25, // number of sessions
      accessibilityCompliance: 95, // percentage
      employeeSatisfaction: 4.6, // survey score (out of 5)
      leedCertLevel: "Platinum",
    },
    {
      id: 7,
      buildingName: "Contoso Retail Space - Edmonton",
      builtYear: 2019,
      location: "West Edmonton Mall, AB",
      buildingType: "Commercial",
      managedSpace: 130000,
      energyConsumption: 160000, // kWh
      waterUsage: 35000, // gallons
      wasteManagement: 80, // percentage
      socialInteraction: 30, // number of sessions
      accessibilityCompliance: 97, // percentage
      employeeSatisfaction: 4.7, // survey score (out of 5)
      leedCertLevel: "Gold",
    },
    {
      id: 8,
      buildingName: "Contoso Eco Park - Saskatoon",
      builtYear: 2020,
      location: "Meewasin Valley, Saskatoon, SK",
      buildingType: "Mixed-Use",
      managedSpace: 70000,
      energyConsumption: 140000, // kWh
      waterUsage: 27000, // gallons
      wasteManagement: 92, // percentage
      socialInteraction: 18, // number of sessions
      accessibilityCompliance: 100, // percentage
      employeeSatisfaction: 4.4, // survey score (out of 5)
      leedCertLevel: "Platinum",
    },
    {
      id: 9,
      buildingName: "Contoso Tower - Victoria",
      builtYear: 2014,
      location: "Downtown Victoria, BC",
      buildingType: "Office",
      managedSpace: 160000,
      energyConsumption: 120000, // kWh
      waterUsage: 22000, // gallons
      wasteManagement: 85, // percentage
      socialInteraction: 20, // number of sessions
      accessibilityCompliance: 90, // percentage
      employeeSatisfaction: 4.2, // survey score (out of 5)
      leedCertLevel: "Silver",
    },
    {
      id: 10,
      buildingName: "Contoso Conference Center - Winnipeg",
      builtYear: 2018,
      location: "The Forks, Winnipeg, MB",
      buildingType: "Event Space",
      managedSpace: 85000,
      energyConsumption: 115000, // kWh
      waterUsage: 19000, // gallons
      wasteManagement: 87, // percentage
      socialInteraction: 15, // number of sessions
      accessibilityCompliance: 98, // percentage
      employeeSatisfaction: 4.6, // survey score (out of 5)
      leedCertLevel: "Gold",
    },
  ];

  return (
    <>
      <Box sx={{ height: "350px", width: "100%", overflow: "auto" }}>
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              lineHeight: "1.5",
              whiteSpace: "normal",
            },

            "& .MuiDataGrid-cell": {
              textAlign: "center", // Centering cell content
            },
          }}
          rows={rows}
          columns={columns}
          initialState={{}}
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};

export default PortfolioGridESGTable;
